import { createSlice } from '@reduxjs/toolkit'
import { gameClose, userLogin } from 'redux-store/thunk/auth.thunk'
import {
  fetchUserInformation,
  updateBalanceAsync
} from 'redux-store/thunk/user.thunk'
import { toggleFavouriteQuestion } from 'games/PredictionMarket/slice-thunk/predictionMarket.thunk'
import { getPayloadFromToken } from 'helpers/common.helpers'

const defaultAuthState = {
  creditWalletWaitQueue: [],
  userInfo: null,
  userDetails: null,
  currencyId: null,
  currencyCode: null,
  isLoggedIn: false,
  showName: false
}

const authSlice = createSlice({
  name: 'authSlice',
  initialState: defaultAuthState,
  reducers: {
    // appendCreditWalletWaitQueue: (state, action) => {
    //   return {
    //     ...state,
    //     creditWalletWaitQueue: [action.payload, ...state.creditWalletWaitQueue]
    //   }
    // },
    // updateCreditWalletWaitQueue: (state, action) => {
    //   let _creditWalletWaitQueue = [...state.creditWalletWaitQueue]
    //   const _userInfoWallet = _creditWalletWaitQueue[_creditWalletWaitQueue.length - 1] ?? state.userInfo.wallet
    //   _creditWalletWaitQueue = _creditWalletWaitQueue?.slice(0, _creditWalletWaitQueue.length - 1)
    //   return {
    //     ...state,
    //     creditWalletWaitQueue: _creditWalletWaitQueue,
    //     userInfo: {
    //       ...state.userInfo,
    //       wallet: _userInfoWallet
    //     }
    //   }
    // },
    updateUserWallet: (state, action) => ({
      ...state,
      userInfo: {
        ...state.userInfo,
        wallet: action.payload
      }
    }),
    setShowName: (state, action) => {
      return {
        ...state,
        showName: !state.showName
      }
    },
    setUserInfo: (state, action) => ({
      ...state,
      userInfo: {
        ...state.userInfo,
        wallet: action.payload
      }
    }),
    setUserToken: (state, action) => {
      const { token, currency } = action.payload

      if (!state.userInfo) {
        state.userInfo = {}
      }

      if (!state.userInfo.user) {
        state.userInfo.user = {}
      }

      state.userInfo.user.token = token
      state.userInfo.user.currency = currency
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(userLogin.fulfilled, (state, action) => {
        const { user, wallet, accessToken } = action.payload
        const payload = getPayloadFromToken(accessToken)
        const currencyId = payload?.currencyId
        const currencyCode = payload?.currencyCode
        return {
          ...state,
          currencyId,
          currencyCode,
          userInfo: { user, wallet },
          isLoggedIn: true
        }
      })
      .addCase(fetchUserInformation.fulfilled, (state, action) => {
        return {
          ...state,
          userDetails: action.payload
        }
      })
      .addCase(toggleFavouriteQuestion.fulfilled, (state, action) => {
        if (!state.userDetails) return state
        return {
          ...state,
          userDetails: {
            ...state.userDetails,
            favouriteQuestions: action.payload?.favouriteQuestionIds ?? state.userDetails.favouriteQuestions
          }
        }
      })
      .addCase(updateBalanceAsync.fulfilled, (state, action) => {
        if (state.userInfo?.wallet) {
          state.userInfo.wallet.balance = action.payload
        }
      })
      .addCase(gameClose.fulfilled, (state, action) => {
        return defaultAuthState
      })
  }
})

export const {
  setUserInfo,
  // appendCreditWalletWaitQueue,
  // updateCreditWalletWaitQueue,
  updateUserWallet,
  setUserToken,
  setShowName
} = authSlice.actions

export default authSlice.reducer
